import React from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';

const Ayarlar = () => {
  return (
    <div className="wrapper">
      <PageHeader 
        title="Ayarlar"
        description="Ayarlarınızı özelleştirin"
      />

      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <h6 className="mb-4">Güvenlik Ayarları</h6>
              <div className="mb-4">
                <h6 className="text-muted mb-3">Şifre Değiştirme</h6>
                <form>
                  <div className="mb-3">
                    <label className="form-label">Mevcut Şifre</label>
                    <input type="password" className="form-control" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Yeni Şifre</label>
                    <input type="password" className="form-control" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Yeni Şifre (Tekrar)</label>
                    <input type="password" className="form-control" />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    <i className="fas fa-key me-2"></i>
                    Şifreyi Güncelle
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
{/* 
        <div className="col-md-6 mb-4">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <h6 className="mb-4">Entegrasyonlar</h6>
              <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between p-3 border rounded mb-2">
                  <div className="d-flex align-items-center">
                    <i className="fab fa-google text-danger fs-4 me-3"></i>
                    <div>
                      <h6 className="mb-0">Google Scholar</h6>
                      <small className="text-muted">Akademik yayınlarınızı senkronize edin</small>
                    </div>
                  </div>
                  <button className="btn btn-sm btn-outline-primary">Bağlan</button>
                </div>
                <div className="d-flex align-items-center justify-content-between p-3 border rounded mb-2">
                  <div className="d-flex align-items-center">
                    <i className="fab fa-researchgate text-success fs-4 me-3"></i>
                    <div>
                      <h6 className="mb-0">ResearchGate</h6>
                      <small className="text-muted">Araştırma profilini senkronize et</small>
                    </div>
                  </div>
                  <button className="btn btn-sm btn-outline-primary">Bağlan</button>
                </div>
                <div className="d-flex align-items-center justify-content-between p-3 border rounded">
                  <div className="d-flex align-items-center">
                    <i className="fab fa-orcid text-success fs-4 me-3"></i>
                    <div>
                      <h6 className="mb-0">ORCID</h6>
                      <small className="text-muted">Akademik kimliğinizi bağlayın</small>
                    </div>
                  </div>
                  <button className="btn btn-sm btn-outline-primary">Bağlan</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <h6 className="mb-4">Sistem Bilgileri</h6>
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded">
                  <div>
                    <small className="text-muted d-block">Yazılım Versiyonu</small>
                    <strong>v1.0.0</strong>
                  </div>
                  <span className="badge bg-success">Güncel</span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded">
                  <div>
                    <small className="text-muted d-block">Son Güncelleme</small>
                    <strong>01.01.2024</strong>
                  </div>
                  <button className="btn btn-sm btn-outline-primary">
                    <i className="fas fa-sync-alt me-2"></i>
                    Güncellemeleri Kontrol Et
                  </button>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded">
                  <div>
                    <small className="text-muted d-block">Depolama Kullanımı</small>
                    <strong>2.5 GB / 10 GB</strong>
                  </div>
                  <div className="progress" style={{ width: '100px', height: '6px' }}>
                    <div className="progress-bar" style={{ width: '25%' }}></div>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center p-3 bg-light rounded">
                  <div>
                    <small className="text-muted d-block">Sistem Durumu</small>
                    <strong>Aktif</strong>
                  </div>
                  <span className="badge bg-success">Çalışıyor</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Ayarlar; 